import { render, staticRenderFns } from "./diagnosis-consultation-modal-toolbar.vue?vue&type=template&id=28b2a101&scoped=true&"
import script from "./diagnosis-consultation-modal-toolbar.ts?vue&type=script&lang=ts&"
export * from "./diagnosis-consultation-modal-toolbar.ts?vue&type=script&lang=ts&"
import style0 from "./diagnosis-consultation-modal-toolbar.scss?vue&type=style&index=0&id=28b2a101&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2a101",
  null
  
)

export default component.exports